import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip, IconButton } from '@mui/material';
import PlayArrow from '@mui/icons-material/PlayArrow';
import PauseRoundedIcon from '@mui/icons-material/PauseRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import CreateRoundedIcon from '@mui/icons-material/CreateRounded';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';

import { AlarmAction } from './ListView';
import { AlarmDefinition } from 'types/types';
import { AlarmManagementPopupRef } from '../Popup/Popup';

interface Props {
  alarmDefinition: AlarmDefinition;
  modalRef: React.RefObject<AlarmManagementPopupRef>;
  setModalType: React.Dispatch<React.SetStateAction<string>>;
  alarmIdToApplyAction: React.MutableRefObject<number | undefined>;
}

const TableActionsCell: React.FC<Props> = ({
  modalRef,
  setModalType,
  alarmDefinition,
  alarmIdToApplyAction,
}) => {
  const navigate = useNavigate();
  const handleEditAlarm = () => {
    navigate(`/alarm-management/edit/${alarmDefinition.id}`);
  };

  const handlePauseAlarm = () => {
    alarmIdToApplyAction.current = alarmDefinition?.id;
    setModalType(AlarmAction.PAUSE);
    modalRef.current?.handleOpenPopup(true);
  };

  const handleActivateAlarm = () => {
    alarmIdToApplyAction.current = alarmDefinition?.id;
    setModalType(AlarmAction.ACTIVATE);
    modalRef.current?.handleOpenPopup(true);
  };

  const handleDuplicateAlarm = () => {
    navigate(`/alarm-management/duplicate`, {
      state: { alarmIdToDuplicate: alarmDefinition?.id ?? -1 },
    });
  };

  const handleDeleteAlarm = () => {
    alarmIdToApplyAction.current = alarmDefinition?.id;
    setModalType(AlarmAction.DELETE);
    modalRef.current?.handleOpenPopup(true);
  };

  return (
    <React.Fragment>
      <Tooltip title="Edit">
        <IconButton onClick={handleEditAlarm}>
          <CreateRoundedIcon />
        </IconButton>
      </Tooltip>
      {alarmDefinition.enabled ? (
        <Tooltip title="Pause">
          <IconButton onClick={handlePauseAlarm}>
            <PauseRoundedIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Activate">
          <IconButton onClick={handleActivateAlarm}>
            <PlayArrow />
          </IconButton>
        </Tooltip>
      )}

      <Tooltip title="Duplicate">
        <IconButton onClick={handleDuplicateAlarm}>
          <ContentCopyRoundedIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton onClick={handleDeleteAlarm}>
          <DeleteRoundedIcon />
        </IconButton>
      </Tooltip>
    </React.Fragment>
  );
};

export default TableActionsCell;
